<template>
  <div :loading="loading" class="budget-grid">
    <div class="grid-header">
      <el-row class="query-block" :gutter="12">
        <el-col :span="4" class="grid-name">{{ budgetTypeName }} </el-col>
        <el-col :span="20" class="query-fields clearfix">
          <el-select v-model="queryParam.buId" placeholder="事业部" clearable filterable @change="onBuChanged">
            <el-option
              v-for="item in buList"
              :label="item.orgName"
              :value="item.orgId"
              :key="item.orgId"
            />
          </el-select>
          <el-select v-model="queryParam.regionId" placeholder="区域" clearable filterable @change="onRegionChanged">
            <el-option
              v-for="item in regionList"
              :label="item.orgName"
              :value="item.orgId"
              :key="item.orgId"
            />
          </el-select>
          <el-select v-model="queryParam.mmr12Code" placeholder="MMR12分类" clearable filterable @change="onMmr12Changed" v-if="budgetType !== 'pocm'">
            <el-option
              v-for="item in mmr12List"
              :label="item.mmr12Name "
              :value="item.mmr12Code"
              :key="item.mmr12Id"
            />
          </el-select>
        </el-col>
      </el-row>
      <el-row class="title-block" :gutter="12">
        <el-col :span="4">&nbsp;</el-col>
        <el-col :span="8">
          <el-row class="title-cell">
            <el-col class="title-main">全年预算</el-col>
            <el-col :span="8" class="title-sub">全部预算</el-col>
            <el-col :span="8" class="title-sub">已用预算</el-col>
            <el-col :span="8" class="title-sub">剩余预算</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row class="title-cell">
            <el-col class="title-main">当季预算</el-col>
            <el-col :span="8" class="title-sub">全部预算</el-col>
            <el-col :span="8" class="title-sub">已用预算</el-col>
            <el-col :span="8" class="title-sub">剩余预算</el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row class="title-cell">
            <el-col class="title-main">本月预算</el-col>
            <el-col class="title-sub">已用预算</el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div class="grid-content">
      <el-row v-for="(stat, index) in statList" :key="index" :gutter="12" class="data-line">
        <el-col :span="4">
          <div class="data-cell budget-code">
            <span v-if="statPocm">{{ stat.mmr12Code }}</span>
            <span v-if="statTr">{{ stat.trCode }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <el-row :gutter="6">
            <el-col :span="8"><div class="data-cell">￥{{ stat.year.total | toThousandslsFilter }}</div></el-col>
            <el-col :span="8"><div class="data-cell">￥{{ stat.year.used | toThousandslsFilter }}</div></el-col>
            <el-col :span="8"><div class="data-cell">￥{{ stat.year.available | toThousandslsFilter }}</div></el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row :gutter="6">
            <el-col :span="8"><div class="data-cell">￥{{ stat.quarter.total | toThousandslsFilter }}</div></el-col>
            <el-col :span="8"><div class="data-cell">￥{{ stat.quarter.used | toThousandslsFilter }}</div></el-col>
            <el-col :span="8"><div class="data-cell">￥{{ stat.quarter.available | toThousandslsFilter }}</div></el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <div class="data-cell">
            ￥{{ stat.month.used | toThousandslsFilter }}
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="grid-footer">
      <el-form :inline="true" class="export-form">
        <el-form-item label="开始月份">
          <el-date-picker
            v-model="exportParam.queryMonthFrom"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            @change="startTimeStatus"
            :picker-options="pickerOptionsStart">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="截止月份">
          <el-date-picker
            v-model="exportParam.queryMonthTo"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            @change="endTimeStatus"
            :picker-options="pickerOptionsEnd">
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="exportCptReport">导出CPT报表</el-button>
      </el-form>
      <v-form ref="export-form" :url="exportUrl" :params="exportParam" />
    </div>
  </div>
</template>

<script>
import baseApi from '@/api/base'
import budgetApi from '@/api/budget'
import vForm from '@/components/v-form'
import { commonUtils } from '@/utils/common'
export default {
  name: 'budget-grid',
  components: {
    vForm
  },
  props: {
    budgetType: {
      type: String,
      default: 'pocm'
    }
  },
  data () {
    return {
      queryParam: {
        buId: '',
        regionId: '',
        mmr12Code: ''
      },
      loading: false,
      buList: [],
      regionList: [],
      mmr12List: [],
      statList: [],
      exportParam: {
        budgetType: this.budgetType,
        queryMonthFrom: '',
        queryMonthTo: ''
      },
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      exportUrl: commonUtils.getApiUrl('/budget/cpt-report/export')
    }
  },
  computed: {
    budgetTypeName () {
      return this.budgetType === 'pocm' ? 'POCM预算' : this.budgetType === 'tr' ? 'TR预算' : ''
    },
    statPocm () {
      return this.budgetType === 'pocm'
    },
    statTr () {
      return this.budgetType === 'tr'
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.queryBuList()
      this.queryMmr12List()
      this.queryBudgetStatList()
      this.initExportParam()
    },

    initExportParam () {
      const curYear = (new Date()).getFullYear()
      const curMonth = (new Date()).getMonth()
      const monthStr = (curMonth + 1) < 10 ? '0' + (curMonth + 1) : '' + (curMonth + 1)
      this.exportParam.queryMonthFrom = curYear + '-' + monthStr
      this.exportParam.queryMonthTo = curYear + '-' + monthStr
    },

    queryBuList () {
      baseApi.queryClientBuList().then(res => {
        if (res.data.resultCode === '0') {
          this.buList = res.data.resultData.buList
        }
      })
    },

    queryMmr12List () {
      baseApi.getMmr12List().then(res => {
        if (res.data.resultCode === '0') {
          this.mmr12List = res.data.resultData.baseMmr12List
        }
      })
    },

    queryBudgetStatList () {
      const params = Object.assign({}, this.queryParam, { budgetType: this.budgetType })
      this.loading = true
      budgetApi.queryBudgetStatList(params).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.statList = res.data.resultData.statList
        }
      }).catch(() => {
        this.loading = false
      })
    },

    onBuChanged (val) {
      this.queryParam.regionId = ''
      this.regionList = []
      this.buList.map(bu => {
        if (bu.orgId === val) {
          this.regionList = bu.subOrgList
        }
      })
      this.queryBudgetStatList()
    },
    onRegionChanged (val) {
      this.queryBudgetStatList()
    },
    onMmr12Changed (val) {
      this.queryBudgetStatList()
    },
    exportCptReport () {
      if (!this.exportParam.queryMonthFrom) {
        this.$alert('请选择CPT报表导出开始月份', '系统提示')
        return
      }
      if (!this.exportParam.queryMonthTo) {
        this.$alert('请选择CPT报表导出截止月份', '系统提示')
        return
      }
      this.$confirm('是否要导出CPT报表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$refs['export-form'].submit()
      }).catch(() => {})
    },

    // 时间开始选择器
    startTimeStatus: function (value) {
      this.orderDateFrom = value
      this.pickerOptionsEnd = {
        disabledDate: time => {
          let beginDateVal = this.exportParam.queryMonthFrom
          if (beginDateVal) {
            return (
              time.getTime() <= new Date(beginDateVal).getTime() - 86400000
            )
          }
        }
      }
    },
    // 时间结束选择器
    endTimeStatus: function (value) {
      this.orderDateTo = value
      this.pickerOptionsStart = {
        disabledDate: time => {
          let endDateVal = this.exportParam.queryMonthTo
          if (endDateVal) {
            return time.getTime() >= new Date(endDateVal).getTime()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.budget-grid {
  .grid-header {
    background-color: #DAE6F7;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-bottom: 10px;
    overflow: hidden;

    .query-block {
      padding: 30px;
      height: 70px;
      .grid-name {
        font-size: 18px;
        font-weight: 700;
      }
      .query-fields {
        text-align: right;

        .el-select {
          width: 200px;
        }
        .el-select+.el-select {
          margin-left: 10px;
        }
      }
    }
    .title-block {
      padding: 30px 0 0 0;
      .title-cell {
        background-color: #BCD4F2;
        text-align: center;
        .title-main {
          font-size: 16px;
          font-weight: 700;
          height: 60px;
          padding: 30px;
        }
        .title-sub {
          padding: 16px;
        }
      }
    }
  }

  .grid-content {
    .data-line {
      margin-top: 10px;
      text-align: center;

      .data-cell {
        background: #fff;
        padding: 20px 20px;
        height: 20px;
      }

      .budget-code {
        font-weight: 700;
      }
    }
  }

  .grid-footer {
    background-color: #DAE6F7;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: right;
    padding: 20px 10px 0 10px;
    margin-top: 10px;

    .export-form {
      .el-date-editor {
        width: 120px;
      }
    }
  }
}
</style>
